import React from 'react'
import './common.css'

export default function Header() {
    return <div>
        <h1 className="header-text">RAT MAZE</h1>
    </div>
}